import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import { Box, Modal, Divider } from "@material-ui/core"
import { useTranslation } from "react-i18next"
import NCText from "../../shared/NCText"
import NCButton from "../../shared/NCButton"

const useStyles = makeStyles(theme => ({
  root: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "520px",
    maxWidth: "95vw",
    maxHeight: "90vh",
    backgroundColor: "#fff",
    boxShadow: "0 8px 40px rgba(0, 0, 0, 0.15)",
    borderRadius: "20px",
    outline: "none",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column"
  },
  header: {
    background: "linear-gradient(135deg, #1EAAC4 0%, #10658E 100%)",
    padding: theme.spacing(3, 4),
    textAlign: "center"
  },
  headerTitle: {
    color: "#fff",
    fontWeight: 700
  },
  body: {
    padding: theme.spacing(3, 4),
    overflowY: "auto",
    flex: 1
  },
  contentTitle: {
    color: theme.palette.primary.dark,
    fontWeight: 600,
    marginBottom: theme.spacing(2),
    textAlign: "center"
  },
  contentText: {
    color: "#555",
    lineHeight: 1.6,
    fontSize: "14px"
  },
  footer: {
    padding: theme.spacing(2, 4, 3),
    display: "flex",
    justifyContent: "center"
  }
}))

// Normalize every <br> variant (<br>, <br/>, <br />, </br>) to a single <br/>
const normalizeBreaks = (html) =>
  html.replace(/<\s*\/?\s*br\s*\/?\s*>/gi, "<br/>")

// Collapse runs of consecutive <br/> tags (e.g. "<br/><br/><br/>") into one
const collapseBreaks = (html) =>
  html.replace(/(<br\/>\s*){2,}/gi, "<br/>")

const formatContent = (content) => {
  if (!content) return ""

  const normalized = content.replace(/\r\n/g, "\n").replace(/\r/g, "\n")
  const paragraphs = normalized.split(/\n\n+/)

  return collapseBreaks(
    normalizeBreaks(
      paragraphs
        .map((para) => {
          const lines = para.split("\n").filter((l) => l.trim())
          const isList = lines.length > 0 && lines.every((l) => /^[⦁•\-•▪▸►]/.test(l.trim()))

          if (isList) {
            const items = lines
              .map((l) => `<li>${l.trim().replace(/^[⦁•\-•▪▸►]\s*/, "")}</li>`)
              .join("")
            return `<ul style="padding-left: 20px; margin: 12px 0; list-style-type: disc; color: #555;">${items}</ul>`
          }

          return `<p style="margin: 0 0 12px 0; color: #555;">${lines.join("<br/>")}</p>`
        })
        .join("")
    )
  )
}

const Introduction = props => {
  const cls = useStyles()
  const { t } = useTranslation()
  const items = props?.data?.data?.data?.results || []

  return (
    <Modal open={props.open} onClose={props.onClose}>
      <Box className={cls.root}>
        <Box className={cls.header}>
          <NCText variant="h5" className={cls.headerTitle}>
            {t("intro_to_app")}
          </NCText>
        </Box>

        {items.length > 0 && (
          <Box className={cls.body}>
            <NCText variant="h6" className={cls.contentTitle}>
              {items[0].title}
            </NCText>
            <NCText
              variant="body2"
              className={cls.contentText}
              dangerouslySetInnerHTML={{
                __html: formatContent(items[0].content)
              }}
            />
          </Box>
        )}

        <Divider />
        <Box className={cls.footer}>
          <NCButton
            variant="contained"
            color="primary"
            onClick={props.onClose}
            style={{ minWidth: 140 }}
          >
            {t("common.close")}
          </NCButton>
        </Box>
      </Box>
    </Modal>
  )
}

export default Introduction
